module.exports = __webpack_public_path__ + "static/media/carrotdownFill.0f31d57d.svg";